import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const ApplicationOverviewSearchSchema = z.object({
    contributors: z.string().optional(),
    versionId: z.string().optional()
});
// Will be lazy loaded from MFE
export const Route = createFileRoute('/org/$organization/$project/app/$application/')({
    validateSearch: (search)=>ApplicationOverviewSearchSchema.parse(search),
    component: ()=>null
});
